module.exports = __webpack_public_path__ + "static/img_1839-3a3d85a9f5efb5cfa169ef597fa495c3.webp";